import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import ScrollToTop from './components/ScrollToTop';
import EasterEggs from './components/EasterEggs';
import Home from './pages/Home';

/**
 * The landing page (Home) ships in the main bundle for the fastest possible LCP.
 * Every other route is code-split so its weight (and the admin's rich-text
 * editor in particular) never loads for a first-time visitor on the homepage.
 */
const Studio = lazy(() => import('./pages/Studio'));
const Eternity = lazy(() => import('./pages/Eternity'));
const EternityPress = lazy(() => import('./pages/EternityPress'));
const TeamMemberDetail = lazy(() => import('./pages/TeamMemberDetail'));
const AdminLogin = lazy(() => import('./pages/admin/Login'));
const AdminDashboard = lazy(() => import('./pages/admin/Dashboard'));
const Remember = lazy(() => import('./pages/Remember'));
const MemoryPage = lazy(() => import('./pages/Memory'));
const Archive = lazy(() => import('./pages/Archive'));
const NotFound = lazy(() => import('./pages/NotFound'));

const RouteFallback = () => (
    <div style={{ minHeight: '100vh', background: '#05060f' }} aria-hidden="true" />
);

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <EasterEggs />
            <Suspense fallback={<RouteFallback />}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/studio" element={<Studio />} />
                    <Route path="/eternity" element={<Eternity />} />
                    <Route path="/eternity/press" element={<EternityPress />} />
                    <Route path="/team/:id" element={<TeamMemberDetail />} />
                    <Route path="/remember" element={<Remember />} />
                    <Route path="/memory" element={<MemoryPage />} />
                    <Route path="/archive" element={<Archive />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
